import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer className="w-100 bg-transparent mt-auto">
      <div className="container text-center py-4">
        <p className="text-muted small mb-0">&copy; {new Date().getFullYear()} Care Concierge. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
